import React, {Fragment} from 'react';
import PersonalTrustpassInformationFormSubmitButton from './InformationFormSubmitButton';
import TextInput from '../../../shared/components/forms/TextInput';
import Textarea from '../../../shared/components/forms/Textarea';
import NumberInput from '../../../shared/components/forms/NumberInput';
import DateSelect from '../../../shared/components/forms/DateSelect';
import Select from '../../../shared/components/forms/Select';
import SelectOptions from '../../../../utils/SelectOptions';

function PersonalTrustpassInformationForm({
  information,
  submitting,
  disabled,
  errors,
  onSave,
  onFocus,
  onChangeValue,
}) {
  return (
    <Fragment>
      <section className="cardSection">
        <div className="ds-formGroup">
          <TextInput
            label="First Name"
            name="first_name"
            placeholder="Enter First Name"
            value={information.first_name || ''}
            error={errors.first_name}
            disabled={disabled}
            onChange={onChangeValue('first_name')}
          />
          <TextInput
            label="Middle Name"
            tip="Optional"
            name="middle_name"
            placeholder="Enter Middle Name"
            value={information.middle_name || ''}
            error={errors.middle_name}
            disabled={disabled}
            onChange={onChangeValue('middle_name')}
          />

          <TextInput
            label="Last Name"
            name="last_name"
            placeholder="Enter Last Name"
            value={information.last_name || ''}
            error={errors.last_name}
            disabled={disabled}
            onChange={onChangeValue('last_name')}
          />
        </div>
        <p className="label">Birth Date</p>
        <DateSelect
          label="Birth Date"
          name="birth_date"
          className="Select"
          value={information.birth_date || ''}
          error={errors.birth_date}
          disabled={disabled}
          onChange={onChangeValue('birth_date')}
          onFocus={onFocus}
        />
        <div className="ds-formGroup">
          <NumberInput
            label="Mobile Number"
            name="phone_number"
            placeholder="Enter Mobile Number"
            value={information.phone_number || ''}
            error={errors.phone_number}
            disabled={disabled}
            onChange={onChangeValue('phone_number')}
          />
          <TextInput
            label="Email Address"
            name="email_address"
            placeholder="Enter Email Address"
            value={information.email_address || ''}
            error={errors.email_address}
            disabled={disabled}
            onChange={onChangeValue('email_address')}
          />
        </div>
        <div className="ds-formGroup">
          <Select
            label="Gender"
            name="gender"
            includeBlank="Select Gender"
            options={SelectOptions.gender}
            value={information.gender || ''}
            error={errors.gender}
            disabled={disabled}
            onChange={onChangeValue('gender')}
            onFocus={onFocus}
          />
          <Select
            label="Civil Status"
            name="civil_status"
            includeBlank="Select Civil Status"
            options={SelectOptions.civil_status}
            value={information.civil_status || ''}
            error={errors.civil_status}
            disabled={disabled}
            onChange={onChangeValue('civil_status')}
            onFocus={onFocus}
          />
        </div>
        <Textarea
          label="Home Address"
          name="home_address"
          placeholder="Enter Home Address"
          value={information.home_address || ''}
          error={errors.home_address}
          disabled={disabled}
          row="3"
          onChange={onChangeValue('home_address')}
          tip="Example: 1234 Maria St., Makati City, 1600"
        />
      </section>

      <PersonalTrustpassInformationFormSubmitButton
        information={information}
        submitting={submitting}
        hide_save={disabled}
        onSave={onSave}
      />
    </Fragment>
  );
}

export default PersonalTrustpassInformationForm;



// WEBPACK FOOTER //
// ./src/features/trustpass/components/personal/InformationForm.js